/**
 * Se a pessoa já viu o tutorial do módulo (MV2-1791).
 *
 * Guardado em `localStorage`, como todas as preferências do dashboard hoje
 * (`src/useApp.ts`, `src/hooks/license.ts`, `IndicatorsDashboard/adminGate.ts`). O nome da
 * chave segue o formato de lá — `indicators_dashboard_last_query`.
 *
 * **Limitação conhecida:** é por navegador, e não por usuário. Quem trocar de máquina, de
 * navegador ou limpar os dados do site vê o tutorial de novo. Preferência por usuário exigiria
 * campo no backend, o que é subtarefa própria — a decisão desta foi ficar no `localStorage`
 * e registrar o limite.
 *
 * Toda leitura e escrita vai em try/catch: em janela privada o acesso pode lançar. Nesse caso
 * a leitura devolve "não viu", que reabre o tutorial a cada visita — é o mesmo custo que o
 * throttle do IndicatorsDashboard aceita, e a alternativa (esconder de quem nunca viu) é pior.
 */

const SEEN_KEY = 'interoperability_tutorial_seen';

export const hasSeenTour = (): boolean => {
  try {
    return localStorage.getItem(SEEN_KEY) === '1';
  } catch {
    return false;
  }
};

export const markTourSeen = (): void => {
  try {
    localStorage.setItem(SEEN_KEY, '1');
  } catch {
    // localStorage indisponível (modo privado); o tutorial volta na próxima visita
  }
};
